module.exports = __webpack_public_path__ + "media/images/favicon-500e59d59d8cd0ad89d5c28c6fd419c9.png";